import React, { useEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import "react-calendar/dist/Calendar.css";
import {
  createCompanyEmployeeHandler,
  editCompanyEmployeeByIdHandler,
  getAllLocationsAndRolesForCompanyHandler,
  getCompanyEmployeeByIdHandler,
  removeDeviceIdFromEmployeeHandler,
 
} from "../../../handlers/companiesHandlers/employeesHandlers/HandlerEmployeesDetails";
import Select from "react-select";
import { LOCALSTORAGE_ITEMS, TYPES } from "../../../util/Constants";
import * as StorageServices from "../../../services/StorageServices";
import { selectStyles } from "../../../util/common";
import Alert from "../../../components/Alert";
import analyticsLogEvent from "../../../services/FirebaseService";
import {closeIcon} from "../../../components/Icons";
function EmployeeDetails(props) {
  const openedRightPanelStyleName = "open";
  const closedRightPanelStyleName = "closed";
  const type = StorageServices.getItem(LOCALSTORAGE_ITEMS.TYPE);
    const companyInfo = StorageServices.getItem(LOCALSTORAGE_ITEMS.COMPANY_INFO)
      ? JSON.parse(StorageServices.getItem(LOCALSTORAGE_ITEMS.COMPANY_INFO))
      : null;
  const availableForms = companyInfo?.availableClientForms || [];

  const defaultFormFields = {
    firstName: "",
    lastName: "",
    phone: "",
    password: "",
    selectedClockingLocations: null,
    selectedRoles: null,
    selectedType: null,
    selectedManagedLocations: null,
    selectedManagedRoles: null,
    deviceId: null,


    signature: null,
    signatureFile: null,
    signatureUploading: false,
  };

  const [state, setState] = useState({
    rightPanelStyleName: closedRightPanelStyleName,
    errorMsg: null,
    clockingLocations: [],
    roles: [],
    type: [TYPES.ADMIN, TYPES.MANAGER, TYPES.WORKER],
    managedLocations: null,
    managedRoles: [],
    isDeleteDeviceIdAlertOpen: false,
    includeInReportsSwitchEnabled: true,
    ...defaultFormFields,
  });

  const signatureFileRef = useRef(null);

  useEffect(() => {
    analyticsLogEvent("page_view", {
      page_title: "EmployeeDetails",
    });
    getFormData();
   
  }, [props.employeeDetailsId]);

  const handleOnChange = (e, input) => {
    if (input === "userType") {
      setState({
        ...state,
        selectedType: e !== null ? e.value : null,
        errorMsg: null,
      });
    } else if (input === "firstName") {
      setState({
        ...state,
        firstName: e.target.value,
        errorMsg: null,
      });
    } else if (input === "lastName") {
      setState({
        ...state,
        lastName: e.target.value,
        errorMsg: null,
      });
    } else if (input === "phone") {
      setState({
        ...state,
        phone: e.target.value,
        errorMsg: null,
      });
    } else if (input === "password") {
      setState({
        ...state,
        password: e.target.value,
        errorMsg: null,
      });
    } else if (input === "signature") {
      setState({
        ...state,
        signature: e.target.value,
        errorMsg: null,
      });
    } else if (input === "clockingLocations") {
      const selectedLocations = e == null ? [] : e.map((l) => l.value);
      setState({
        ...state,
        errorMsg: null,
        selectedClockingLocations: selectedLocations,
      });
    } else if (input === "managedLocations") {
      const eLocations = e == null ? [] : e.map((managedLocation) => managedLocation.value);
      setState({
        ...state,
        errorMsg: null,
        selectedManagedLocations: eLocations,
      });
    } else if (input === "roles") {
      setState({
        ...state,
        errorMsg: null,
        selectedRoles:
          e !== null
            ? e.map((role) => {
              return role?.value;
            })
            : [],
      });
    } else if (input === "managedRoles") {
      setState({
        ...state,
        errorMsg: null,
        selectedManagedRoles:
          e !== null
            ? e.map((managedRole) => {
              return managedRole?.value;
            })
            : [],
      });
    }
  };


  const openSignatureInput = (ev) => {
    ev?.preventDefault?.();
    signatureFileRef.current?.click();
  };

  const onSignatureFileChange = async (ev) => {
    const file = ev.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      setState((s) => ({ ...s, errorMsg: "Please upload an image file (PNG/JPG)." }));
      ev.target.value = "";
      return;
    }

    const MAX_MB = 0.5;
    if (file.size > MAX_MB * 1024 * 1024) {
      setState((s) => ({ ...s, errorMsg: `Image too large. Max ${MAX_MB}MB.` }));
      ev.target.value = "";
      return;
    }

    setState((s) => ({ ...s, signatureUploading: true, errorMsg: null }));

    try {
      const base64 = await fileToDataUrl(file);
      setState((s) => ({
        ...s,
        signature: base64,
        signatureFile: file,
        signatureUploading: false,
        errorMsg: null,
      }));
    } catch (e) {
      console.error("onSignatureFileChange: fileToDataUrl: ", e);
      setState((s) => ({ ...s, signatureUploading: false, errorMsg: "Error reading image file." }));
    } finally {
      ev.target.value = "";
    }
  };

  const fileToDataUrl = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });


  const getAllSelectedClockingLocationsSelectOptions = () =>
    state.clockingLocations
      ?.filter((e) => state.selectedClockingLocations?.includes(e.id))
      .map((e) => {
        return {
          label: e.name,
          value: e.id,
        };
      });

  const getAllSelectedManagedLocationsSelectOptions = () =>
    state.managedLocations
      ?.filter((e) => state.selectedManagedLocations?.includes(e.id))
      .map((e) => {
        return {
          label: e.name,
          value: e.id,
        };
      });

  const getAllRolesSelectOptions = () =>
    state.roles
      ?.filter((e) => state.selectedRoles?.includes(e.id))
      .map((e) => {
        return {
          label: e.name,
          value: e.id,
        };
      });

  const getAllSelectedManagedRolesSelectOptions = () =>
    state.managedRoles
      ?.filter((e) => state.selectedManagedRoles?.includes(e.id))
      .map((e) => {
        return {
          label: e.name,
          value: e.id,
        };
      });

  const selectAllManagedLocations = () => {
    setState({
      ...state,
      errorMsg: null,
      selectedManagedLocations: state.managedLocations?.map((managedLocation) => managedLocation.id),
    });
  };

  const selectAllManagedRoles = () => {
    setState({
      ...state,
      errorMsg: null,
      selectedManagedRoles: state.managedRoles?.map((managedRole) => managedRole.id),
    });
  };

  const selectAllClockingLocations = () => {
    setState({
      ...state,
      errorMsg: null,
      selectedClockingLocations: state.clockingLocations.map((clockingLocation) => clockingLocation.id),
    });
  };

  const selectAllRoles = () => {
    setState({
      ...state,
      errorMsg: null,
      selectedRoles: state.roles.map((role) => role.id),
    });
  };

  const getFormData = () => {
    getAllLocationsAndRolesForCompanyHandler(props.companyId).then((allLocationsAndRolesResponse) => {
      if (props.employeeDetailsId === "") {
        // NEW EMPLOYEE
        setState({
          ...state,
          type: [TYPES.ADMIN, TYPES.MANAGER, TYPES.WORKER],
          roles: allLocationsAndRolesResponse.data.roles,
          managedRoles: allLocationsAndRolesResponse.data.roles,
          clockingLocations: allLocationsAndRolesResponse.data.locations,
          managedLocations: allLocationsAndRolesResponse.data.locations,
          rightPanelStyleName: openedRightPanelStyleName,
          includeInReportsSwitchEnabled: true,
          errorMsg: null,
          signature: "",
          signatureFile: null,
          signatureUploading: false,
          ...defaultFormFields,
        });
      } else {
        // EDIT EMPLOYEE
        getCompanyEmployeeByIdHandler(props.employeeDetailsId).then((employeeResponse) => {
          setState({
            ...state,
            type: [TYPES.ADMIN, TYPES.MANAGER, TYPES.WORKER],
            selectedType: employeeResponse.data.account.type,

            firstName: employeeResponse.data.account.firstName,
            lastName: employeeResponse.data.account.lastName,
            phone: employeeResponse.data.account.phone,

            roles: allLocationsAndRolesResponse.data.roles,
            selectedRoles: employeeResponse.data.account.roles,

            managedRoles: allLocationsAndRolesResponse.data.roles,
            selectedManagedRoles: employeeResponse.data.account.managedRoles,

            clockingLocations: allLocationsAndRolesResponse.data.locations,
            selectedClockingLocations: employeeResponse.data.account.clockingLocations,

            managedLocations: allLocationsAndRolesResponse.data.locations,
            selectedManagedLocations: employeeResponse.data.account.managedLocations,

            deviceId: employeeResponse.data.account.deviceId,
            includeInReportsSwitchEnabled: employeeResponse.data.account.includeInReports,
            isDeleteDeviceIdAlertOpen: false,
            rightPanelStyleName: openedRightPanelStyleName,
            errorMsg: null,

            signature: employeeResponse.data.account.signature || "",
            signatureFile: null,
            signatureUploading: false,
          });
        });
      }
    });
  };

  // Build bodies (keep logic same, but signature comes from state)
  let bodyNewAccount;

  if (type === TYPES.MANAGER) {
    bodyNewAccount = {
      companyId: props.companyId,
      firstName: state.firstName,
      lastName: state.lastName,
      phone: state.phone,
      password: state.password,
      clockingLocations: state.selectedClockingLocations,
      roles: state.selectedRoles,
      type: "WORKER",
      managedLocations: state.selectedManagedLocations,
      managedRoles: state.selectedManagedRoles,
      includeInReports: state.includeInReportsSwitchEnabled,


      signature: state.signature,
    };
  } else {
    bodyNewAccount = {
      companyId: props.companyId,
      firstName: state.firstName,
      lastName: state.lastName,
      phone: state.phone,
      password: state.password,
      clockingLocations: state.selectedClockingLocations,
      roles: state.selectedRoles,
      type: state.selectedType,
      managedLocations: state.selectedManagedLocations,
      managedRoles: state.selectedManagedRoles,
      includeInReports: state.includeInReportsSwitchEnabled,

      signature: state.signature,
    };
  }

  let bodyEditAccount;

  if (state.password === "") {
    bodyEditAccount = {
      employeeId: props.employeeDetailsId,
      companyId: props.companyId,
      firstName: state.firstName,
      lastName: state.lastName,
      phone: state.phone,
      clockingLocations: state.selectedClockingLocations,
      roles: state.selectedRoles,
      type: state.selectedType,
      managedLocations: state.selectedManagedLocations,
      managedRoles: state.selectedManagedRoles,
      deviceId: state.deviceId,
      includeInReports: state.includeInReportsSwitchEnabled,


      signature: state.signature,
    };
  } else {
    bodyEditAccount = {
      companyId: props.companyId,
      employeeId: props.employeeDetailsId,
      firstName: state.firstName,
      lastName: state.lastName,
      password: state.password,
      phone: state.phone,
      clockingLocations: state.selectedClockingLocations,
      roles: state.selectedRoles,
      type: state.selectedType,
      managedLocations: state.selectedManagedLocations,
      managedRoles: state.selectedManagedRoles,
      deviceId: state.deviceId,
      includeInReports: state.includeInReportsSwitchEnabled,

      signature: state.signature,
    };
  }

  const createNewAccount = () => {
    if (validateData()) {
      createCompanyEmployeeHandler(bodyNewAccount).then((response) => {
        if (response.data.error == null) {
          setState({
            ...state,
            errorMsg: null,
            ...defaultFormFields,
          });
          props.closeRightPanel(true);
        } else {
          setState({
            ...state,
            errorMsg: response.data.message,
          });
        }
      });
    }
  };

  const editExistingAccount = () => {
    if (validateData()) {
      editCompanyEmployeeByIdHandler([bodyEditAccount]).then((response) => {
        if (response.data.error == null) {
          setState({
            ...state,
            errorMsg: null,
          });
          props.closeRightPanel(true);
        } else {
          setState({
            ...state,
            errorMsg: response.data.message,
          });
        }
      });
    }
  };

  const handleSubmit = () => {
    if (props.employeeDetailsId === "") {
      createNewAccount();
    } else {
      editExistingAccount();
    }
  };

  const validateData = () => {
    if (
      !state.firstName ||
      !state.lastName ||
      !state.phone ||
      (!props.employeeDetailsId && (state.password.length === 0 || state.password === "")) ||
      (type !== TYPES.MANAGER && type !== TYPES.WORKER && !state.selectedType) ||
      (type == TYPES.MANAGER && state.selectedClockingLocations.length === 0) ||
      (type == TYPES.MANAGER && state.selectedRoles.length === 0)
    ) {
      setState({
        ...state,
        errorMsg: <FormattedMessage id="PleaseFillInAllFields" defaultMessage="PleaseFillInAllFields" />,
      });
      return false;
    }

    if (!state.phone.startsWith("+")) {
      setState({
        ...state,
        errorMsg: <FormattedMessage id="InvalidPhoneNumber" defaultMessage="InvalidPhoneNumber" />,
      });
      return false;
    }

    setState({
      ...state,
      errorMsg: null,
    });
    return true;
  };

  const deleteDeviceId = (employeeId) => {
    const body = {
      deviceId: state.deviceId,
    };
    removeDeviceIdFromEmployeeHandler(employeeId, body).then(() => {
      getFormData();
    });
  };

  const openDeleteAlert = (e) => {
    e.stopPropagation();
    setState({
      ...state,
      isDeleteDeviceIdAlertOpen: true,
    });
  };

  const hideAlert = () => {
    setState({
      ...state,
      isDeleteDeviceIdAlertOpen: false,
    });
  };

  const toggleSwitch = () => {
    setState({
      ...state,
      includeInReportsSwitchEnabled: !state.includeInReportsSwitchEnabled,
    });
  };



  return (
    <>
      {state.isDeleteDeviceIdAlertOpen && (
        <Alert
          title={<FormattedMessage id="DeleteParam" values={{ param: <FormattedMessage id="Device" defaultMessage="Device" /> }} />}
          contentRow1={<FormattedMessage id="DoYouWantToDeleteParam" values={{ param: state.deviceId }} />}
          deleteAction1={() => deleteDeviceId(props.employeeDetailsId)}
          deleteText1={<FormattedMessage id="DeleteParam" values={{ param: <FormattedMessage id="ThisDevice" defaultMessage="ThisDevice" /> }} />}
          cancelAction={() => hideAlert()}
          cancelText={<FormattedMessage id="Cancel" defaultMessage="Cancel" />}
          hideAlert={() => hideAlert()}
        />
      )}

      <section className="form-container">
        <div className="details-form">
          {type !== TYPES.MANAGER && type !== TYPES.WORKER && (
            <div className="form-group">
              <div className="row">
                <label className="label" htmlFor="userType">
                  <FormattedMessage id="UserType" defaultMessage="UserType" />{" "}
                  <span className="required-chip">
                    <FormattedMessage id="Required" defaultMessage="Required" />
                  </span>
                </label>
              </div>
              <div className="row">
                <FormattedMessage id="UserType" defaultMessage="UserType">
                  {(placeholder) => (
                    <Select
                      className="select"
                      options={state.type.map((t) => ({ label: t, value: t }))}
                      value={{ label: state.selectedType, value: state.selectedType }}
                      onChange={(e) => handleOnChange(e, "userType")}
                      placeholder={placeholder}
                      noOptionsMessage={() => <FormattedMessage id="NoOptionsAvailable" />}
                      id="userType"
                      styles={selectStyles}
                      components={{ IndicatorSeparator: () => null }}
                    />
                  )}
                </FormattedMessage>
              </div>
            </div>
          )}

          {/* First name */}
          <div className="form-group">
            <div className="row">
              <label className="label" htmlFor="firstName">
                <FormattedMessage id="FirstName" defaultMessage="FirstName" />{" "}
                <span className="required-chip">
                  <FormattedMessage id="Required" defaultMessage="Required" />
                </span>
              </label>
            </div>
            <div className="row">
              <FormattedMessage id="FirstName" defaultMessage="FirstName">
                {(placeholder) => (
                  <input
                    className="input"
                    type="text"
                    onChange={(e) => handleOnChange(e, "firstName")}
                    maxLength={80}
                    placeholder={placeholder}
                    autoComplete="off"
                    id="firstName"
                    value={state.firstName}
                  />
                )}
              </FormattedMessage>
            </div>
          </div>

          {/* Last name */}
          <div className="form-group">
            <div className="row">
              <label className="label" htmlFor="lastName">
                <FormattedMessage id="LastName" defaultMessage="LastName" />{" "}
                <span className="required-chip">
                  <FormattedMessage id="Required" defaultMessage="Required" />
                </span>
              </label>
            </div>
            <div className="row">
              <FormattedMessage id="LastName" defaultMessage="LastName">
                {(placeholder) => (
                  <input
                    className="input"
                    type="text"
                    onChange={(e) => handleOnChange(e, "lastName")}
                    maxLength={100}
                    placeholder={placeholder}
                    autoComplete="off"
                    id="lastName"
                    value={state.lastName}
                  />
                )}
              </FormattedMessage>
            </div>
          </div>

          {/* Phone */}
          <div className="form-group">
            <div className="row">
              <label className="label" htmlFor="phone">
                <FormattedMessage id="PhoneNumber" defaultMessage="Phone Number" />{" "}
                <span className="required-chip">
                  <FormattedMessage id="Required" defaultMessage="Required" />
                </span>
              </label>
            </div>
            <div className="row">
              <FormattedMessage id="PhoneNumberFormat" defaultMessage="PhoneNumberFormat">
                {(placeholder) => (
                  <input
                    autoComplete="new-password"
                    className="input"
                    type="tel"
                    onChange={(e) => handleOnChange(e, "phone")}
                    maxLength={100}
                    placeholder={placeholder}
                    id="phone"
                    value={state.phone}
                  />
                )}
              </FormattedMessage>
            </div>
          </div>

          {/* Device */}
          {props.employeeDetailsId !== "" && state.deviceId && (
            <div className="form-group">
              <div className="row">
                <label className="label" htmlFor="deviceId">
                  <FormattedMessage id="DeviceUsed" defaultMessage="DeviceUsed" />
                </label>
              </div>
              <div className="row">
                <div className="single-option">{state.deviceId}</div>
                <a onClick={(e) => openDeleteAlert(e, props.employeeDetailsId)} className="icon remove-icon ml-auto">
                  {closeIcon}
                </a>
              </div>
            </div>
          )}

          {/* Password */}
          <div className="form-group">
            <div className="row">
              <label className="label" htmlFor="pwd">
                <FormattedMessage id="Password" defaultMessage="Password" />{" "}
                <span className="required-chip">
                  <FormattedMessage id="Required" defaultMessage="Required" />
                </span>
              </label>
            </div>
            <div className="row">
              <FormattedMessage id="Password" defaultMessage="Password">
                {(placeholder) => (
                  <input
                    className="input"
                    type="password"
                    onChange={(e) => handleOnChange(e, "password")}
                    maxLength={100}
                    placeholder={placeholder}
                    autoComplete="new-password"
                    id="pwd"
                    value={state.password}
                  />
                )}
              </FormattedMessage>
            </div>
          </div>

          {availableForms.length > 0 && <div className="form-group">
            <div className="row">
              <label className="label">Signature</label>
            </div>

            <div className="row buttons-container flex-start small-buttons" >
              <button
                type="button"
                className="btn btn-default"
                onClick={openSignatureInput}
                disabled={state.signatureUploading}
              >
                {state.signatureUploading ? "Reading..." : state.signature ? "Replace" : "Upload image"}
              </button>

              {state.signature ? (
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setState((s) => ({ ...s, signature: "", signatureFile: null }))}
                  disabled={state.signatureUploading}
                >
                  Remove
                </button>
              ) : null}

              <input
                ref={signatureFileRef}
                type="file"
                accept="image/*"
                className="hide"
                onChange={onSignatureFileChange}
              />
            </div>

            {state.signature &&
              <div className="row" style={{ marginTop: 8 }}>
                <img
                  src={state.signature} 
                  alt="Signature preview"
                  style={{
                    maxWidth: 260,
                    maxHeight: 140,
                    border: "1px solid #e5e7eb",
                    borderRadius: 8,
                  }}
                />
              </div>
            }
          </div>}


          {/* Clocking locations */}
          {state.selectedType !== "ADMIN" && (
            <div className="form-group">
              <div className="row">
                <label className="label" htmlFor="clockingLocations">
                  <FormattedMessage id="ClockInLocations" defaultMessage="ClockInLocations" />{" "}
                  <span className="required-chip">
                    <FormattedMessage id="Required" defaultMessage="Required" />
                  </span>
                </label>
                <a onClick={() => selectAllClockingLocations()} className="link">
                  <FormattedMessage id="SelectAll" defaultMessage="SelectAll" />
                </a>
              </div>
              <div className="row">
                <FormattedMessage id="ClockInLocations" defaultMessage="ClockInLocations">
                  {(placeholder) => (
                    <Select
                      className="select"
                      options={state.clockingLocations.map((clockingLocation) => ({
                        label: clockingLocation.name,
                        value: clockingLocation.id,
                      }))}
                      value={getAllSelectedClockingLocationsSelectOptions()}
                      onChange={(e) => handleOnChange(e, "clockingLocations")}
                      placeholder={placeholder}
                      noOptionsMessage={() => <FormattedMessage id="NoOptionsAvailable" />}
                      id="clockingLocations"
                      styles={selectStyles}
                      isMulti={true}
                      components={{ IndicatorSeparator: () => null }}
                    />
                  )}
                </FormattedMessage>
              </div>
            </div>
          )}

          {/* Roles */}
          {state.selectedType !== "ADMIN" && (
            <div className="form-group">
              <div className="row">
                <label className="label" htmlFor="roles">
                  <FormattedMessage id="Roles" defaultMessage="Roles" />{" "}
                  <span className="required-chip">
                    <FormattedMessage id="Required" defaultMessage="Required" />
                  </span>
                </label>
                <a onClick={() => selectAllRoles()} className="link">
                  <FormattedMessage id="SelectAll" defaultMessage="SelectAll" />
                </a>
              </div>
              <div className="row">
                <FormattedMessage id="Roles" defaultMessage="Roles">
                  {(placeholder) => (
                    <Select
                      className="select"
                      options={state.roles?.map((role) => ({ label: role.name, value: role.id }))}
                      value={getAllRolesSelectOptions()}
                      onChange={(e) => handleOnChange(e, "roles")}
                      placeholder={placeholder}
                      noOptionsMessage={() => <FormattedMessage id="NoOptionsAvailable" />}
                      id="roles"
                      styles={selectStyles}
                      isMulti={true}
                      components={{ IndicatorSeparator: () => null }}
                    />
                  )}
                </FormattedMessage>
              </div>
            </div>
          )}

          {/* Managed Locations */}
          {state.selectedType === "MANAGER" && (
            <div className="form-group">
              <div className="row">
                <label className="label" htmlFor="managedLocations">
                  <FormattedMessage id="ManagedLocations" defaultMessage="ManagedLocations" />
                </label>
                <a onClick={() => selectAllManagedLocations()} className="link">
                  <FormattedMessage id="SelectAll" defaultMessage="SelectAll" />
                </a>
              </div>
              <div className="row">
                <FormattedMessage id="ManagedLocations" defaultMessage="ManagedLocations">
                  {(placeholder) => (
                    <Select
                      className="select"
                      options={state.managedLocations?.map((managedLocation) => ({
                        label: managedLocation.name,
                        value: managedLocation.id,
                      }))}
                      value={getAllSelectedManagedLocationsSelectOptions()}
                      onChange={(e) => handleOnChange(e, "managedLocations")}
                      placeholder={placeholder}
                      noOptionsMessage={() => <FormattedMessage id="NoOptionsAvailable" />}
                      id="managedLocations"
                      styles={selectStyles}
                      isMulti={true}
                      components={{ IndicatorSeparator: () => null }}
                    />
                  )}
                </FormattedMessage>
              </div>
            </div>
          )}

          {/* Managed Roles */}
          {state.selectedType === "MANAGER" && (
            <div className="form-group">
              <div className="row">
                <label className="label" htmlFor="managedRoles">
                  <FormattedMessage id="ManagedRoles" defaultMessage="ManagedRoles" />
                </label>
                <a onClick={() => selectAllManagedRoles()} className="link">
                  <FormattedMessage id="SelectAll" defaultMessage="SelectAll" />
                </a>
              </div>
              <div className="row">
                <FormattedMessage id="ManagedRoles" defaultMessage="ManagedRoles">
                  {(placeholder) => (
                    <Select
                      className="select"
                      options={state.managedRoles?.map((managedRole) => ({
                        label: managedRole.name,
                        value: managedRole.id,
                      }))}
                      value={getAllSelectedManagedRolesSelectOptions()}
                      onChange={(e) => handleOnChange(e, "managedRoles")}
                      placeholder={placeholder}
                      noOptionsMessage={() => <FormattedMessage id="NoOptionsAvailable" />}
                      id="managedRoles"
                      styles={selectStyles}
                      isMulti={true}
                      components={{ IndicatorSeparator: () => null }}
                    />
                  )}
                </FormattedMessage>
              </div>
            </div>
          )}

          {/* Include in reports */}
          <div className="form-group">
            <div className="row switch-row">
              <label className="label" htmlFor="IncludeInReports">
                <FormattedMessage id="IncludeInReports" />
              </label>
              <div
                onClick={() => toggleSwitch()}
                className={state.includeInReportsSwitchEnabled ? "ml-auto switch labeled on" : "ml-auto switch labeled off"}
              >
                <input type="text" tabIndex="-1" />
                <div className="labels">
                  <div className="dot"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="row buttons-container">
            <button onClick={() => props.closeRightPanel()} className="btn btn-default">
              <FormattedMessage id="Cancel" defaultMessage="Cancel" />
            </button>
            <button onClick={() => handleSubmit()} className="btn btn-success" disabled={state.signatureUploading}>
              <FormattedMessage id="Save" defaultMessage="Save" />
            </button>
          </div>

          {state.errorMsg && <div className="error">&#9888;&nbsp;{state.errorMsg}</div>}
        </div>
      </section>
    </>
  );
}

export default EmployeeDetails;
